import { RouteLocationNormalized, NavigationGuardReturn } from 'vue-router';
import { checkApplicationSanity, validateUUIDGuard } from '@/application/shared/infrastructure/routeGuards';
import SaveAndExitSuccess from '@/application/shared/infrastructure/views/SaveAndExitSuccess.vue';
import VisionApplication from '@/application/vision/infrastructure/views/VisionApplication.vue';
import PlanList from '@/planList/infrastructure/views/PlanList.vue';
import QuoteForm from '@/quote/infrastructure/views/QuoteForm.vue';
import EnrollmentLayout from '@/shared/infrastructure/layouts/EnrollmentLayout.vue';
import { APPLICATION_TYPES } from '@hfc/common/src/types/ApplicationTypes';
import DentalAndVisionContinueApplying from '@/shared/infrastructure/views/DentalAndVisionContinueApplying.vue';
import { CarrierList } from '@hfc/ui-core';

export const visionRouter = {
  path: '/vision',
  name: 'Vision',
  redirect: {
    name: 'VisionQuote'
  },
  children: [{
    path: 'quote',
    name: 'VisionQuote',
    props: {
      applicationType: APPLICATION_TYPES.VISION,
      titlePrefix: 'Off Exchange'
    },
    component: QuoteForm,
  }, {
    path: 'quote-senior',
    name: 'VisionQuoteSenior',
    props: {
      applicationType: APPLICATION_TYPES.VISION,
      titlePrefix: 'Senior'
    },
    component: QuoteForm,
  }, {
    path: 'plan-list',
    name: 'VisionPlanList',
    props: {
      applicationType: APPLICATION_TYPES.VISION,
    },
    component: PlanList,
    beforeEnter: (_to: RouteLocationNormalized, _from: RouteLocationNormalized): NavigationGuardReturn => checkApplicationSanity('visionQuote', 'VisionQuote')
  }, {
    path: '',
    name: 'VisionApplicationLayout',
    component: EnrollmentLayout,
    props: {
      applicationType: APPLICATION_TYPES.VISION,
    },
    children: [{
      path: 'application',
      name: 'VisionApplication',
      component: VisionApplication,
      beforeEnter: (_to: RouteLocationNormalized, _from: RouteLocationNormalized): NavigationGuardReturn => checkApplicationSanity('visionPlan', 'VisionPlanList')
    }, {
      path: 'application/:uuid',
      name: 'VisionApplicationResume',
      component: VisionApplication,
      beforeEnter: (to: RouteLocationNormalized, _from: RouteLocationNormalized): NavigationGuardReturn => validateUUIDGuard(to, 'VisionApplication')
    }]
  }, {
    path: 'application/:uuid/continue-applying',
    name: 'VisionApplicationContinueApplying',
    component: DentalAndVisionContinueApplying,
    props: {
      applicationType: APPLICATION_TYPES.VISION
    }
  }, {
    path: 'save-and-exit',
    name: 'VisionSaveAndExit',
    component: SaveAndExitSuccess,
    beforeEnter: (_to: RouteLocationNormalized, _from: RouteLocationNormalized): NavigationGuardReturn => checkApplicationSanity('visionSaveAndExit', 'VisionQuote'),
    props: {
      applicationType: APPLICATION_TYPES.VISION,
      carrier: CarrierList.BlueShield
    },
  }]
};
